
      var _path, _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgQuestionMark = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 49,
  height: 49,
  viewBox: "0 0 49 49",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("mask", {
  id: "question-mark_69c7d10f844b6ea6__a",
  style: {
    maskType: "alpha"
  },
  maskUnits: "userSpaceOnUse",
  x: 0,
  y: 0,
  width: 49,
  height: 49
}, _path || (_path = /*#__PURE__*/React.createElement("path", {
  transform: "matrix(-1 0 0 1 48.65 .538)",
  fill: "var(--theme-light, #f9f3fb)",
  d: "M0 0h48v48H0z"
}))), _g || (_g = /*#__PURE__*/React.createElement("g", {
  mask: "url(#question-mark_69c7d10f844b6ea6__a)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M24.651 4.538a20 20 0 1 1 0 40 20 20 0 0 1 0-40z",
  fill: "url(#question-mark_69c7d10f844b6ea6__b)"
}), /*#__PURE__*/React.createElement("path", {
  d: "M24.651 33.285a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75zm0-20a6.25 6.25 0 0 0-6.25 6.25 1.25 1.25 0 0 0 2.5 0 3.75 3.75 0 1 1 6.58 2.46l-.265.275-.295.25-.617.463a7.492 7.492 0 0 0-.89.807c-1.28 1.365-2.013 3.215-2.013 5.745a1.25 1.25 0 0 0 2.5 0c0-1.895.49-3.135 1.338-4.035l.187-.19.2-.182.22-.18.548-.408.385-.312a6.25 6.25 0 0 0-4.128-10.943z",
  fill: "url(#question-mark_69c7d10f844b6ea6__c)"
}))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
  id: "question-mark_69c7d10f844b6ea6__b",
  x1: 4.651,
  y1: 4.538,
  x2: 44.651,
  y2: 44.538,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-bright, #e3d2e9)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-primary, #810ea9)"
})), /*#__PURE__*/React.createElement("linearGradient", {
  id: "question-mark_69c7d10f844b6ea6__c",
  x1: 19.494,
  y1: 13.703,
  x2: 26.564,
  y2: 37.685,
  gradientUnits: "userSpaceOnUse"
}, /*#__PURE__*/React.createElement("stop", {
  stopColor: "var(--theme-light, #f9f3fb)"
}), /*#__PURE__*/React.createElement("stop", {
  offset: 1,
  stopColor: "var(--theme-light, #f9f3fb)"
})))));

      const __svgRaw = "<svg width=\"49\" height=\"49\" viewBox=\"0 0 49 49\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\r\n    <mask id=\"c1xu23kina\" style=\"mask-type:alpha\" maskUnits=\"userSpaceOnUse\" x=\"0\" y=\"0\" width=\"49\" height=\"49\">\r\n        <path transform=\"matrix(-1 0 0 1 48.65 .538)\" fill=\"var(--theme-light, #f9f3fb)\" d=\"M0 0h48v48H0z\"/>\r\n    </mask>\r\n    <g mask=\"url(#c1xu23kina)\">\r\n        <path d=\"M24.651 4.538a20 20 0 1 1 0 40 20 20 0 0 1 0-40z\" fill=\"url(#jt33302kpb)\"/>\r\n        <path d=\"M24.651 33.285a1.875 1.875 0 1 0 0 3.75 1.875 1.875 0 0 0 0-3.75zm0-20a6.25 6.25 0 0 0-6.25 6.25 1.25 1.25 0 0 0 2.5 0 3.75 3.75 0 1 1 6.58 2.46l-.265.275-.295.25-.617.463a7.492 7.492 0 0 0-.89.807c-1.28 1.365-2.013 3.215-2.013 5.745a1.25 1.25 0 0 0 2.5 0c0-1.895.49-3.135 1.338-4.035l.187-.19.2-.182.22-.18.548-.408.385-.312a6.25 6.25 0 0 0-4.128-10.943z\" fill=\"url(#hzkcalf61c)\"/>\r\n    </g>\r\n    <defs>\r\n        <linearGradient id=\"jt33302kpb\" x1=\"4.651\" y1=\"4.538\" x2=\"44.651\" y2=\"44.538\" gradientUnits=\"userSpaceOnUse\">\r\n            <stop stop-color=\"var(--theme-bright, #e3d2e9)\"/>\r\n            <stop offset=\"1\" stop-color=\"var(--theme-primary, #810ea9)\"/>\r\n        </linearGradient>\r\n        <linearGradient id=\"hzkcalf61c\" x1=\"19.494\" y1=\"13.703\" x2=\"26.564\" y2=\"37.685\" gradientUnits=\"userSpaceOnUse\">\r\n            <stop stop-color=\"var(--theme-light, #f9f3fb)\"/>\r\n            <stop offset=\"1\" stop-color=\"var(--theme-light, #f9f3fb)\"/>\r\n        </linearGradient>\r\n    </defs>\r\n</svg>\r\n";

      function __resolveCssVarsInSvg(svgMarkup) {
        if (typeof window === 'undefined' || !document?.documentElement) {
          return svgMarkup;
        }

        const htmlEl = document.documentElement;
        const bodyEl = document.body;

        function __readCustomProperty(name) {
          let v = getComputedStyle(htmlEl).getPropertyValue(name).trim();
          if (!v && bodyEl) {
            v = getComputedStyle(bodyEl).getPropertyValue(name).trim();
          }
          return v;
        }

        function __expandVarToken(fullMatch, seen) {
          if (!seen) seen = new Set();
          const m = String(fullMatch)
            .trim()
            .match(/^var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)$/i);
          if (!m) return fullMatch;
          const varName = m[1];
          const fallbackRaw = m[2] != null ? String(m[2]).trim() : '';
          if (seen.has(varName)) {
            return fallbackRaw || fullMatch;
          }
          seen.add(varName);
          let specified = __readCustomProperty(varName);
          if (!specified) {
            return fallbackRaw || fullMatch;
          }
          specified = specified.trim();
          if (/^var\s*\(/i.test(specified)) {
            return __expandVarToken(specified, seen) || fallbackRaw || fullMatch;
          }
          return specified || fallbackRaw || fullMatch;
        }

        return svgMarkup.replace(
          /var\(\s*(--[^),\s]+)(?:\s*,\s*([^)]+))?\s*\)/gi,
          (fullMatch) => __expandVarToken(fullMatch, new Set())
        );
      }

      function __getSvg() {
        return __resolveCssVarsInSvg(__svgRaw);
      }

      function __getBg() {
        const resolved =__resolveCssVarsInSvg(__svgRaw);

        const encoded = encodeURIComponent(resolved)
          .replace(/'/g, '%27')
          .replace(/"/g, '%22');
        return "url('data:image/svg+xml;charset=utf-8," + encoded + "')"; }

      export default Object.assign(
        new String(__webpack_public_path__ + "Assets/question-mark.69c7d10f844b6ea6bf656143c5d832ab.svg"),
        {
          React: SvgQuestionMark,
          svgClassName: undefined,
          svg: __getSvg,
          bg: __getBg
        }
      );
      